module.exports = __webpack_public_path__ + "static/media/ATA.f649047e.png";